import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AwardData } from "../../entry/server/game.ts";
import { gameRepo } from "../../repo/game-repo.ts";
import { AppContext } from "../../context/app-context.tsx";
import AdminPageTitle from "../admin-pages/admin-page-title.tsx";
import PaginationView from "../../componrnts/pagination.tsx";
import { Pagination } from "../../lib/api.ts";
import { awardTypeLabel } from "./award-form-fields.tsx";

export default function AwardsList() {
  const [awards, setAwards] = useState<AwardData[]>([]);
  const [pagination, setPagination] = useState<Pagination | null>(null);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const { setMessage } = useContext(AppContext);

  useEffect(() => {
    const fetchAwards = async () => {
      setLoading(true);
      try {
        const response = await gameRepo.getAwards(page);
        if (!response.status || !response.data) {
          setMessage({ type: "error", message: response.message || "دریافت لیست جوایز ناموفق بود." });
          setAwards([]);
          return;
        }
        setAwards(response.data);
        setPagination(response.pagination ?? null);
      } catch {
        setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
        setAwards([]);
      } finally {
        setLoading(false);
      }
    };

    void fetchAwards();
  }, [page, setMessage]);

  const onDelete = async (id: number) => {
    if (!window.confirm("این جایزه حذف شود؟")) return;

    try {
      const response = await gameRepo.deleteAward(id);
      if (!response.status) {
        setMessage({ type: "error", message: response.message || "حذف جایزه ناموفق بود." });
        return;
      }
      setAwards((prev) => prev.filter((item) => item.id !== id));
      setMessage({ type: "success", message: "جایزه با موفقیت حذف شد." });
    } catch {
      setMessage({ type: "error", message: "خطا در ارتباط با سرور. دوباره تلاش کنید." });
    }
  };

  return (
    <section className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <AdminPageTitle title="جوایز بازی" />
        <Link
          to="/admin/awards/new"
          className="rounded-xl bg-indigo-500 px-4 py-2 text-sm font-medium text-white transition hover:bg-indigo-400"
        >
          ایجاد جایزه
        </Link>
      </div>

      {loading ? (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">
          در حال دریافت لیست جوایز...
        </div>
      ) : !awards.length ? (
        <div className="rounded-2xl border border-slate-800 bg-slate-900/60 p-6 text-slate-300">جایزه‌ای یافت نشد.</div>
      ) : (
        <>
          <div className="overflow-x-auto rounded-2xl border border-slate-800 bg-slate-900/60">
            <table className="min-w-full divide-y divide-slate-800 text-sm">
              <thead className="bg-slate-900/80">
                <tr>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">شناسه</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">عنوان</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">نوع</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">رتبه</th>
                  <th className="px-4 py-3 text-right font-medium text-slate-300">عملیات</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-800">
                {awards.map((award) => (
                  <tr key={award.id} className="transition hover:bg-slate-900">
                    <td className="whitespace-nowrap px-4 py-3 text-slate-300">{award.id}</td>
                    <td className="max-w-md truncate px-4 py-3 text-slate-100" title={award.title}>
                      {award.title || "—"}
                    </td>
                    <td className="whitespace-nowrap px-4 py-3 text-slate-300">{awardTypeLabel(award.type)}</td>
                    <td className="whitespace-nowrap px-4 py-3 text-slate-300">{award.rank}</td>
                    <td className="px-4 py-3">
                      <div className="flex flex-wrap gap-2">
                        <Link
                          to={`/admin/awards/${award.id}/edit`}
                          className="inline-flex rounded-lg border border-indigo-700 px-3 py-1.5 text-xs text-indigo-200 transition hover:border-indigo-500"
                        >
                          ویرایش
                        </Link>
                        <button
                          type="button"
                          onClick={() => void onDelete(award.id)}
                          className="inline-flex rounded-lg border border-rose-800 px-3 py-1.5 text-xs text-rose-200 transition hover:border-rose-600"
                        >
                          حذف
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {pagination ? <PaginationView pagination={pagination} onPageChange={setPage} /> : null}
        </>
      )}
    </section>
  );
}
